import React from "react"
import useCustomTranslation from "@hooks/useCustomTranslation"
import { useRedirectToPro, useSiteMetadata } from "@hooks/siteURLs"
import StatementModule from "@modules/StatementModule"

const BuySellBanner = ({ dataEvents = [] }) => {
  const { t } = useCustomTranslation()
  const url = useRedirectToPro()
  const { url: contactUsUrl } = useSiteMetadata("contact-us")

  const buttons = [
    {
      text: t("buy_metal_scrap"),
      as: "link",
      url: contactUsUrl,
      useNavigate: false,
      theme: "blue-bg",
      inverted: false,
      className: "w-[auto] md:w-[auto]",
    },
    {
      text: t("sell_metal_scrap"),
      as: "link",
      url: url,
      useNavigate: false,
      theme: "blue-bg",
      inverted: true,
      className: "w-[auto] md:py-[10px]",
    },
  ].map((button, idx) => {
    if (dataEvents[idx]) {
      return {
        ...button,
        dataEvent: dataEvents[idx],
      }
    }
    return button
  })

  const params = {
    theme: "gray2-bg",
    text: [
      {
        class: "w-[325px] md:!w-[600px] desk:!w-[960px] desk:!text-[24px]",
        text: t("Metals_CoreBusiness"),
      },
    ],
    buttonWrapperClassName: "flex-col items-center md:flex-row desk:!gap-4",
    buttons,
  }

  return <StatementModule {...params} />
}

export default BuySellBanner
